import { useMutation } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";
import {
  PayoutReceipt,
  ReceiptApiResponse,
  ReceiptKind,
} from "../../components/NotificationsCentre/types";

const RECEIPT_ROUTE_BY_KIND: Record<ReceiptKind, string> = {
  payout: API_ROUTES.GET_RECEIPT_PAYOUT,
  "bank-transfer": API_ROUTES.GET_RECEIPT_BANK_TRANSFER,
  "klasha-wire": API_ROUTES.GET_RECEIPT_KLASHA_WIRE,
};

export const fetchReceipt = async ({
  kind,
  id,
}: {
  kind: ReceiptKind;
  id: string;
}): Promise<PayoutReceipt> => {
  const response = await api.get<ReceiptApiResponse | PayoutReceipt>(
    `${RECEIPT_ROUTE_BY_KIND[kind]}/${id}`
  );

  const payload = response.data;

  if (payload && typeof payload === "object" && "data" in payload) {
    return (payload as ReceiptApiResponse).data;
  }

  return payload as PayoutReceipt;
};

export const useFetchReceipt = () => {
  return useMutation({
    mutationFn: fetchReceipt,
  });
};
